import { DecimalPipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ResultSimulationL2 } from '../../../mortgage/models/result-simulationL2.model';
import { CommonService } from '../../../vass-core/services/common.service';
import { PreSimulatorModel } from '../../models/pre-simulator.model';
import { RecoverUser } from '../../models/recoverUser.model';
import { Holder, UserDataModel } from '../../models/user-data.model';

@Injectable()
export class UserDataService {
  private updateValues: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private userData: UserDataModel = new UserDataModel();
  private isFromSimulate: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private secondHolder: BehaviorSubject<Holder> = new BehaviorSubject(null);

  public resultSimulate: ResultSimulationL2;
  public isRegister: boolean = false;

  constructor(
    private decimalPipe: DecimalPipe,
    private http: CommonService,
  ) {}

  subscribeChanges() {
    return this.updateValues;
  }

  detectedChanges() {
    this.updateValues.next(true);
  }

  getUserData() {
    return this.userData;
  }

  setUserData(userData: UserDataModel) {
    Object.assign(this.userData, userData);
  }

  saveDataEconomic(userData: any) {
    this.userData.level2Data.isMore2Holders = userData.isMore2Holders;
    this.userData.level2Data.expensesOtherLoad = userData.expensesOtherLoad;
    this.userData.level2Data.membersFamily = userData.membersFamily;
    this.userData.level2Data.holders = userData.holders;
    this.parseDataHolders(this.userData.level2Data.holders);
  }

  getSecondHolder() {
    return this.secondHolder;
  }

  saveData(userData: any) {
    this.userData.level2Data.titularNumber = userData.numberHolders;
    this.userData.level2Data.signatureDate = userData.signatureDate
      ? new Date(parseInt(userData.signatureDate, 10))
      : '';
    this.userData.level2Data.squareMeters = userData.homeData.squareMeters;
    this.userData.level2Data.postCode = userData.homeData.zipCode;
  }

  setLevel1Data(level1Data: PreSimulatorModel) {
    this.userData.level1Data = level1Data;
  }

  setLevel2Data(level2Data: any) {
    Object.assign(this.userData.level2Data, level2Data);
  }

  getIsFromSimulate() {
    return this.isFromSimulate.getValue();
  }

  setIsFromSimulate(isFromSimulate) {
    this.isFromSimulate.next(isFromSimulate);
  }

  clear() {
    this.userData = new UserDataModel();
    this.detectedChanges();
  }

  mapperUserData(recoverUser: RecoverUser) {
    this.userData.id = recoverUser.id;
    this.userData.status = recoverUser.status;

    this.userData.level2Data.isMore2Holders =
      recoverUser.economicStudyData.isMore2Holders;
    this.userData.level2Data.expensesOtherLoad =
      recoverUser.economicStudyData.expensesOtherLoad;
    this.userData.level2Data.membersFamily = recoverUser.economicStudyData.membersFamily;
    this.userData.level2Data.holders = recoverUser.economicStudyData.holders;
    this.userData.level2Data.titularNumber = recoverUser.mortgagesData.numberHolders;
    this.userData.level2Data.signatureDate = recoverUser.mortgagesData.signatureDate
      ? new Date(parseInt(recoverUser.mortgagesData.signatureDate, 10))
      : '';
    this.userData.level2Data.postCode = recoverUser.mortgagesData.homeData.zipCode;
    this.userData.level2Data.squareMeters =
      recoverUser.mortgagesData.homeData.squareMeters;

    if (!this.isRegister) {
      this.userData.level1Data.location = recoverUser.mortgagesData.homeData.location
        ? recoverUser.mortgagesData.homeData.location
        : '1';
      this.userData.level1Data.isHabitualHousing =
        recoverUser.mortgagesData.homeData.isFirsthome;
      this.userData.level1Data.isNewHome = recoverUser.mortgagesData.homeData.isNewHome;
      this.userData.level1Data.mortgageAmount = recoverUser.mortgagesData.mortgageAmount
        ? recoverUser.mortgagesData.mortgageAmount
        : '160000';
      this.userData.level1Data.propertyPrice = recoverUser.mortgagesData.homeData
        .propertyPrice
        ? recoverUser.mortgagesData.homeData.propertyPrice
        : '200000';
      this.userData.level1Data.savingsMade = recoverUser.mortgagesData.savingsMade;
      this.userData.level1Data.termInYears = recoverUser.mortgagesData.termInYears
        ? recoverUser.mortgagesData.termInYears
        : '25';
      this.userData.level1Data.isSubsidizedHousing =
        recoverUser.mortgagesData.homeData.isSubsidizedHousing;
    }

    this.parseDataHolders(this.userData.level2Data.holders);

    this.detectedChanges();
    if (recoverUser.economicStudyData.holders.length > 1) {
      this.secondHolder.next(recoverUser.economicStudyData.holders[1]);
    }
  }

  parseDataHolders(holders: Array<Holder>) {
    holders.forEach(
      (holder) =>
        (holder.birthDate = holder.birthDate
          ? new Date(parseInt(holder.birthDate, 10))
          : ''),
    );
  }

  public getTotalMonthlyIncome() {
    let totalAmount = 0;
    if (this.userData.level2Data && this.userData.level2Data.holders) {
      this.userData.level2Data.holders.forEach(
        (e) =>
          (totalAmount = totalAmount + parseFloat(e.holderEmploymentData.monthlyIncome)),
      );
    }
    return isNaN(totalAmount) ? 0 : this.decimalPipe.transform(totalAmount, '1.2-2');
  }
}
